import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './StatusTabSwitcher.module.scss';

export type StatusTab = 'unpublished' | 'published';

interface StatusTabSwitcherProps {
  activeTab: StatusTab;
  onChange: (tab: StatusTab) => void;
}

export const StatusTabSwitcher: React.FC<StatusTabSwitcherProps> = ({ activeTab, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.tabContainer}>
      <div
        className={`${styles.tabItem} ${activeTab === 'unpublished' ? styles.active : ''}`}
        onClick={() => onChange('unpublished')}
        role="tab"
        aria-selected={activeTab === 'unpublished'}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onChange('unpublished');
          }
        }}
      >
        <div className={`${styles.tabButton} ${activeTab === 'unpublished' ? styles.active : ''}`}>
          <span className={`${styles.tabLabel} ${activeTab === 'unpublished' ? styles.active : ''}`}>
            {t('phishingTemplateManager.unpublished')}
          </span>
        </div>
      </div>

      <div
        className={`${styles.tabItem} ${activeTab === 'published' ? styles.active : ''}`}
        onClick={() => onChange('published')}
        role="tab"
        aria-selected={activeTab === 'published'}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onChange('published');
          }
        }}
      >
        <div className={`${styles.tabButton} ${activeTab === 'published' ? styles.active : ''}`}>
          <span className={`${styles.tabLabel} ${activeTab === 'published' ? styles.active : ''}`}>
            {t('phishingTemplateManager.published')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default StatusTabSwitcher;